export default __webpack_public_path__ + "static/media/1870.5634abaf.png";